import { render, staticRenderFns } from "./LoginHistoryTable.vue?vue&type=template&id=634b568d"
import script from "./LoginHistoryTable.vue?vue&type=script&lang=js"
export * from "./LoginHistoryTable.vue?vue&type=script&lang=js"
import style0 from "./LoginHistoryTable.vue?vue&type=style&index=0&id=634b568d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports